export default __webpack_public_path__ + "static/media/jacuzi.693d89de.png";